import type { useSegmentAnalysis } from "./use-segment-analysis"
import type { SegmentReport } from "../types"

import { useSegmentAnalysisPortfolioQuery } from "./use-segment-analysis-queries"
import { getSegmentReport } from "../utils/segment-analysis-utils"

type SegmentAnalysisModel = ReturnType<typeof useSegmentAnalysis>

/**
 * The report for ANY segment, not just the selected one. A plan opened from the
 * Map (or a related-company chip) belongs to its own segment, which is usually not
 * the grid selection, so `model.report` would feed the wrong segment's evidence to
 * GenerateModal. Mirrors the model's own report resolution: backend payload in
 * backend mode, the demo report (then the payload) otherwise. Reads the same
 * cached portfolio query the model uses (react-query dedupes it).
 */
export function useSegmentReportFor(
  model: SegmentAnalysisModel,
  segmentId: string | null | undefined
): SegmentReport | null {
  const payload = useSegmentAnalysisPortfolioQuery(!model.state.useMockData).data
  if (!segmentId) return null
  if (segmentId === model.selectedSegment?.id) return model.report
  if (model.dataSource === "backend") return payload?.reports[segmentId] ?? null
  return getSegmentReport(segmentId) ?? payload?.reports[segmentId] ?? null
}
